import { StrokeColorUpdater } from "./StrokeColorUpdater";
export async function loadStrokeColorUpdater(engine, refresh = true) {
    await engine.addParticleUpdater("strokeColor", (container) => new StrokeColorUpdater(container), refresh);
}
